import { render, staticRenderFns } from "./Ruler.vue?vue&type=template&id=1d1015f9"
import script from "./Ruler.vue?vue&type=script&lang=js"
export * from "./Ruler.vue?vue&type=script&lang=js"
import style0 from "./Ruler.vue?vue&type=style&index=0&id=1d1015f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports